<template>
<div class="d-flex">
    <div class="d-flex" v-if="twobuttons">
      <div @click="changevalue(true)" class="input-new-boll " :class="{'actived': value}">
        <i class="fas fa-check-circle mr-1"></i> Sim
      </div>
      <div @click="changevalue(false)" v-if="simornot" class="input-new-boll ml-3" :class="{'notactived': !value}">
        <i class="fas fa-ban mr-1"></i> Não
      </div>
    </div>
    <div class="d-flex" v-if="switchbutton">
      <div @click="changevalue(true)" v-if="switchguarantee" class="input-new-boll " :class="{'actived': value}">
        <i class="fas fa-check-circle mr-1"></i> Sim
      </div>
      <div @click="changevalue(false)" v-else class="input-new-boll" :class="{'notactived': !value}">
        <i class="fas fa-ban mr-1"></i> Não
      </div>
    </div>
</div>
</template>

<script>
export default {
  name: 'inputnewboll',
  props: {
    simornot: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: false
    },
    disable: {
      type: Boolean,
      default: false
    },
    twobuttons: {
      type: Boolean,
      default: false
    },
    switchbutton: {
      type: Boolean,
      default: false
    },
    switchguarantee: {
      type: Boolean,
      default: false
    }

  },
  watch: {
    value (newvalue) {
      this.$emit('valueEmit', newvalue)
    },
    disable (newDisable) {
      this.setCursorStyle(newDisable)
    }
  },
  data () {
    return {
    }
  },
  mounted () {
    this.setCursorStyle(this.disable)
  },
  methods: {
    changevalue (value) {
      if (this.disable) return
      if (this.simornot) {
        this.value = value
        console.log(this.simornot)
        console.log(value)
      } else {
        this.value = !this.value
      }
    },
    setCursorStyle (disable) {
      const elements = this.$el.querySelectorAll('.input-new-boll')
      for (const element of elements) {
        element.style.cursor = disable ? 'default' : 'pointer'
      }
    }
  }

}
</script>

<style scoped>
.input-new-boll{
  height: 2rem;
  width: 100px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  color: grey;
  border: 1px solid gray;
  border-radius: 10px;
}
.actived{
  color: white;
  background: #008144;
  border: none;
}
.notactived{
  color: white;
  background: red;
  border: none;
}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/ocurrence/components/addocurrence/components/inputnewboll.vue